module.exports = __webpack_public_path__ + "img/Ellipse-bg.3147687e.svg";